import React, { useEffect, useState, useMemo } from "react";

import axios from "axios";
import { Col, Modal, Popover, Row, Tooltip, Typography } from "antd";
import { Button, Checkbox, Drawer, Input, Layout, List, message } from "antd";
import {
  CarOutlined,
  DashboardOutlined,
  EnvironmentOutlined,
  EyeOutlined,
  LeftOutlined,
  MenuOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Content } from "antd/es/layout/layout";
import styled from "styled-components";
import TrackingMap from "../../../Reusablecomponents/TrackingMap";
import { CALL_API } from "../../../Common/api";
import { useSelector } from "react-redux";
import { marker } from "leaflet";
import truck from "../../../assets/images/truck.jpg";
import { set } from "immutable";

const TrackingWrap = styled.div`
  .header {
    display: flex;
    align-items: center;
    padding: 0 20px;
    background: #1d4174;
    color: white;
    font-size: 16px;
  }

  .content {
    padding: 20px;
    background: #f4f4f4;
    // overflow-y: auto;
  }

  .ant-list-item {
    display: flex;
    align-items: center;
    background: white;
    padding: 10px;
    border-radius: 5px;
    margin-bottom: 5px;
  }
  .ant-drawer {
    position: fixed;
    left: 50px;
    inset: 0;
    z-index: 1000;
    pointer-events: none;
    color: rgba(0, 0, 0, 0.88);
  }
  .ant-drawer-left {
    left: 50px !important;
  }
`;

const LiveTracking = () => {
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [getAllVehicles, setGetAllVehicles] = useState([]);
  const [selectedVehicleIds, setSelectedVehicleIds] = useState([]);
  const [vehicleImages, setVehicleImages] = useState({});
  const [selectedVehicleList, setSelectedVehicleList] = useState([]);
  const [minimapVehicle, setMinimapVehicle] = useState(null);

  const [currentTime, setCurrentTime] = useState(new Date());

  const [allUpdatedVehicleIds, setAllUpdatedVehicleIds] = useState({});

  const API_ENDPOINT =
    "https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/liveTracking/updateUnits";

  const findvehicle = async (vehicleId) => {
    try {
      const allvehicleId = getAllVehicles.map((vehicle) => vehicle.id);
      const response = await axios.post(API_ENDPOINT, {
        token:
          "2f98a65e766e3cbf17c9c7c52e238e58CA4C183D189FC3B4E6437699904FFDAD66487A5E",
        unitIds: vehicleId?.length > 0 ? vehicleId : allvehicleId,
      });
      if (response?.status === 200) {
        const updated = getAllVehicles.map((vehicle) => {
          const vehicleData = response?.data?.data?.[vehicle.id];
          const tripsInfo = vehicleData?.find((item) => item.trips)?.trips;
          return {
            ...vehicle,
            latitude: tripsInfo?.to?.y ?? vehicle.latitude,
            longitude: tripsInfo?.to?.x ?? vehicle.longitude,
            endlatitude: tripsInfo?.from?.y ?? vehicle.latitude,
            endlongitude: tripsInfo?.from?.x ?? vehicle.longitude,
          };
        });

        // setAllUpdatedVehicleIds(response.data);
        setGetAllVehicles(updated);
        setSelectedVehicleList(
          selectedVehicleIds?.length > 0
            ? updated?.filter((val) => selectedVehicleIds.includes(val.id))
            : updated
        );
        // setSelectedVehicleIds(selectedVehicleIds)
      }
    } catch (error) {
      console.error("Error updating units:", error);
    }
  };

 

  useEffect(() => {
    const allvehicleId = getAllVehicles.map((vehicle) => vehicle.id);
    const fetchVehicles = () => {
      findvehicle(
        selectedVehicleIds?.length > 0 ? selectedVehicleIds : allvehicleId
      );
    };

    // Call findvehicle immediately when selectedVehicleIds change
    fetchVehicles();

    // Set interval to call findvehicle every 15 seconds
    const interval = setInterval(fetchVehicles, 15000);

    return () => clearInterval(interval); // Cleanup on unmount or dependency change
  }, [selectedVehicleIds, getAllVehicles]); // Re-run effect when dependencies change

  const filteredVehicless =
    selectedVehicleIds.length === 0
      ? getAllVehicles
      : getAllVehicles.filter((val) => selectedVehicleIds.includes(val.id));

  const filteredVehicles =
    searchTerm.trim() === ""
      ? getAllVehicles
      : getAllVehicles?.filter((val) =>
          val?.name?.toLowerCase().includes(searchTerm.toLowerCase())
        );

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchVehicleImage = async (vid) => {
    try {
      const { data } = await axios.get(
        `https://ks5jby85id.execute-api.us-east-2.amazonaws.com/Prod/liveTracking/getvehicleImages?attId=${vid}`
      );
      setVehicleImages((prevImages) => ({
        ...prevImages,
        [vid]: data?.data?.ImageURL || truck,
      }));
    } catch (error) {
      console.error(`Error fetching image for vehicle ${vid}:`, error);
      setVehicleImages((prevImages) => ({
        ...prevImages,
        [vid]: truck,
      }));
    }
  };

  const handleCheckboxChange = async (checked, vehicleId) => {
    setSelectedVehicleIds((prev) =>
      prev.includes(vehicleId)
        ? prev.filter((id) => id !== vehicleId)
        : [...prev, vehicleId]
    );
  };

  const checkAllCheckbox = (checked) => {
    if (checked.target.checked) {
      setSelectedVehicleIds(filteredVehicless?.map((item) => item?.id));
    } else {
      setSelectedVehicleIds([]);
    }
  };

  const fetchAllupdateVehicle = async (data) => {
    try {
      const allvehicleId = data.map((vehicle) => vehicle.id);
      const response = await axios.post(API_ENDPOINT, {
        token:
          "2f98a65e766e3cbf17c9c7c52e238e58CA4C183D189FC3B4E6437699904FFDAD66487A5E",
        unitIds: allvehicleId,
      });
      setAllUpdatedVehicleIds(response.data);
    } catch (error) {
      console.error("Error updating units:", error);
    }
  };

  //vehicle List
  const getVehicleList = (sessionId) => {
    const script = document.createElement("script");
    script.src = `https://hst-api.wialon.com/wialon/ajax.html?svc=core/search_items&params=${encodeURIComponent(
      JSON.stringify({
        spec: {
          itemsType: "avl_unit",
          propName: "sys_name",
          propValueMask: "*",
          sortType: "sys_name",
        },
        force: 1,
        flags: 2098177,
        from: 0,
        to: 0,
      })
    )}&sid=${sessionId}&callback=handleVehicleResponse`;

    window.handleVehicleResponse = async (data) => {
      if (data.items) {
        const vehicles = data.items.map((vehicle) => {
          fetchVehicleImage(vehicle.id); // Fetch image for each vehicle
          return {
            id: vehicle.id,
            name: vehicle.nm,
            km: vehicle.cnm_km || 0,
            positions: data?.display_name || "Unknown Location",
            netconn: vehicle.netconn || false,
            direction: vehicle.direction !== undefined ? vehicle.direction : 45,
            latitude: vehicle.pos?.y || 0,
            longitude: vehicle.pos?.x || 0,
          };
        });

        setGetAllVehicles(vehicles);
        fetchAllupdateVehicle(vehicles);
        if (selectedVehicleList?.length === 0) {
          setSelectedVehicleList(vehicles);
        }
      }
    };

    document.body.appendChild(script);
  };

  //login API
  const handleLogin = async () => {
    const script = document.createElement("script");
    script.src = `https://hst-api.wialon.com/wialon/ajax.html?svc=token/login&params=${encodeURIComponent(
      JSON.stringify({
        token:
          "59e1859840b2bcfd7c336ddb6b6db696BB09F67D870CFC8E9A5735EEF2DA3729E4EE4550",
        duration: 0,
      })
    )}&callback=handleResponse`;

    window.handleResponse = (data) => {
      if (data.eid) {
        getVehicleList(data.eid);
      }
    };

    document.body.appendChild(script);
  };

  const fetchLocation = async (lat, lon) => {
    try {
      const response = await fetch(
        `https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json?access_token=pk.eyJ1Ijoicm9iZXJ0a3BtIiwiYSI6ImNtNml6aWs1dzA0dWwybHM4aGd2NWl2NmgifQ.AOsGlqDkaT6FSAMor3Grow`
      );
      const data = await response.json();
      return data?.features?.[0]?.place_name || "Unknown Location";
    } catch (error) {
      console.error("Error fetching location:", error);
      return "Unknown Location";
    }
  };

  const LocationText = ({ lat, lon }) => {
    const [location, setLocation] = useState("Fetching...");

    useEffect(() => {
      if (lat && lon) {
        fetchLocation(lat, lon).then(setLocation);
      }
    }, [lat, lon]);

    return <Typography.Text>{location}</Typography.Text>;
  };

  useEffect(() => {
    handleLogin();
  }, []);

  // useEffect(() => {
  //   const interval = setInterval(() => {

  //     setSelectedVehicleIds(selectedVehicleIds);
  //   }, 20000);

  //   return () => clearInterval(interval);
  // }, []);

  return (
    <>
      {/* <Button type="pri mary" onClick={() => setOpen(true)}>
        Open
      </Button> */}
      <TrackingMap
        vehicles={selectedVehicleList}
        vehicleImages={vehicleImages}
        truck={truck}
        selectedVehicleIds={selectedVehicleIds}
        minimapVehicle={minimapVehicle}
      />

      <div
        className="sidebox"
        style={{
          width: open ? "300px" : "10px",
          height: `calc(100vh - 80px)`,
          background: "#fff",
          marginLeft: "-20px",
          position: "absolute",
          top: "80px",
          scrollbarWidth: "thin",
          scrollbarColor: "#ccc #fff",
        }}
      >
        {" "}
        <Button
          type="text"
          style={{
            position: "absolute",
            right: "-15px",
            top: "50%",
            color: "#2c963d",
            borderRadius: "50px",
            border: "3px solid #FFFFFF",
            backgroundColor: "#D0D5DD",
          }}
          icon={open ? <LeftOutlined /> : <RightOutlined />}
          onClick={() => setOpen(!open)}
        />
        {open ? (
          <Content className="content p-3">
            <Input.Search
              placeholder="Search..."
              style={{ marginBottom: 10 }}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <Checkbox onChange={(checked) => checkAllCheckbox(checked)}>
              Select All
            </Checkbox>
            <List
              style={{ overflowY: "scroll", height: `calc(100vh - 160px)` }}
              dataSource={[...filteredVehicles]}
              renderItem={(item) => {
                const isOnline = item.netconn === 1;
                const formattedTime = currentTime.toLocaleString("en-GB", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                  second: "2-digit",
                });
                const vehicleDetails = (
                  <div style={{ width: 280, padding: 12 }}>
                    <Typography.Title level={5} style={{ marginBottom: 8 }}>
                      {item.name}
                    </Typography.Title>
                    <Typography.Text
                      type="secondary"
                      style={{ display: "block", marginBottom: 12 }}
                    >
                      {formattedTime}
                    </Typography.Text>

                    <Row
                      align="middle"
                      style={{
                        padding: "8px 12px",
                        background: "#f5f5f5",
                        borderRadius: 6,
                        marginBottom: 8,
                      }}
                    >
                      <Col span={2}>
                        <EnvironmentOutlined />
                      </Col>
                      <Col span={22}>
                        <LocationText
                          lat={
                            allUpdatedVehicleIds?.data?.[item?.id]?.find(
                              (item) => item?.trips
                            )?.trips?.to?.y
                          }
                          lon={
                            allUpdatedVehicleIds?.data?.[item?.id]?.find(
                              (item) => item?.trips
                            )?.trips?.to?.x
                          }
                        />
                      </Col>
                    </Row>

                    <Row gutter={8}>
                      <Col span={12}>
                        <Row
                          align="middle"
                          style={{
                            padding: "8px",
                            background: "#f5f5f5",
                            borderRadius: 6,
                          }}
                        >
                          <Col span={4}>
                            <CarOutlined />
                          </Col>
                          <Col span={20}>
                            <Typography.Text>
                              {allUpdatedVehicleIds?.data?.[item.id]?.find(
                                (item) => item.trips
                              )?.trips?.curr_speed ?? 0}{" "}
                              Km
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                      <Col span={12}>
                        <Row
                          align="middle"
                          style={{
                            padding: "8px",
                            background: "#f5f5f5",
                            borderRadius: 6,
                          }}
                        >
                          <Col span={4}>
                            <DashboardOutlined />
                          </Col>
                          <Col span={20}>
                            <Typography.Text>
                              {allUpdatedVehicleIds?.data?.[item.id]?.find(
                                (item) => item.trips
                              )?.trips?.odometer ?? 0}{" "}
                              km
                            </Typography.Text>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                );

                return (
                  <Popover
                    content={vehicleDetails}
                    placement="right"
                    trigger="hover"
                  >
                    <List.Item
                      style={{ cursor: "pointer" }}
                      onDoubleClick={() => setMinimapVehicle(item?.id)}
                    >
                      <Checkbox
                        checked={selectedVehicleIds.includes(item.id)}
                        onChange={(e) =>
                          handleCheckboxChange(e.target?.checked, item.id)
                        }
                      />
                      {item.isStatic ? (
                        <strong style={{ marginRight: "auto" }}>
                          {item.name}
                        </strong>
                      ) : (
                        <>
                          {/* <CarOutlined
                            style={{ marginLeft: 10, marginRight: 10 }}
                          /> */}
                          {/* <img src={truck} alt="truck" width={20} height={20} /> */}
                          <img
                            src={
                              vehicleImages[item.id]
                                ? vehicleImages[item.id]
                                : truck
                            } // Get the correct image for each vehicle
                            alt="Vehicle"
                            width={30}
                            height={30}
                            onError={(e) => (e.target.src = truck)}
                          />

                          {item.name}
                          <Tooltip
                            title={isOnline ? "Engine is ON" : "Engine is OFF"}
                          >
                            <CarOutlined
                              style={{
                                marginLeft: 10,
                                marginRight: 10,
                                color: isOnline ? "green" : "red",
                              }}
                            />
                          </Tooltip>
                          <Tooltip
                            title={
                              isOnline ? "Unit is Online" : "Unit is Offline"
                            }
                          >
                            <div
                              style={{
                                width: "7px",
                                height: "7px",
                                borderRadius: "50%",
                                backgroundColor: isOnline ? "green" : "red",
                              }}
                            ></div>
                          </Tooltip>
                        </>
                      )}
                    </List.Item>
                  </Popover>
                );
              }}
            />
          </Content>
        ) : (
          <></>
        )}
      </div>
      {/* <div style={{ position: "relative", height: "100%", width: "100%" }}> */}

      {/* </div> */}
    </>
  );
};

export default LiveTracking;
